import { render, staticRenderFns } from "./TurnstilesArchive.vue?vue&type=template&id=d13242c4&scoped=true"
import script from "./TurnstilesArchive.vue?vue&type=script&lang=js"
export * from "./TurnstilesArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13242c4",
  null
  
)

export default component.exports